import enums from "@/enums";

const hasElec = state => state.energies && state.energies !== 'gas' ? 1 : 0;
const hasGas = state => state.energies && state.energies !== 'elec' ? 1 : 0;
const hasElecMeterType = state => state.electricity.meter.type.length > 0;
const hasMono = state => state.electricity.meter.type.indexOf("mono") !== -1 ? 1 : 0;
const hasTou = state => state.electricity.meter.type.indexOf("tou") !== -1 ? 1 : 0;
const hasInjectionBase = state => state.electricity.meter.type.indexOf("injectionBase") !== -1 ? 1 : 0;
const hasInjectionTou = state => state.electricity.meter.type.indexOf("injectionTou") !== -1 ? 1 : 0;
const hasNight = state => state.electricity.meter.type.indexOf("night") !== -1 ? 1 : 0;
const isTempOffer = state => state.unoccupiedType === 'waiting' ? 1 : 0;
const electricityProduct = state => state.electricity.product;
const hasSolarPanel = state => state.electricity.solarPanel;
const electricitySolarPanelScenario = state => state.electricity.solarPanelScenario;
const electricitySolarPanelPower = state => state.electricity.solarPanelPower;
const electricitySolarPanelNumber = state => state.electricity.solarPanelNumber;
const electricitySolarPanelCertification = state => state.electricity.solarPanelCertification;
const electricityRate = state => state.rates.electricity;
const electricityPreviousProvider = (state, getters, rootState) => {
  return rootState.common.elecProviders.find(provider => provider.id === state.electricity.previousProvider);
}
const isElectricityMeterOpen = state => state.electricity.meter.status === 'open';
const electricityDeliveryDate = state => state.electricity.deliveryDate;
const electricityOpenMeterDate = state => state.electricity.openMeterDate;
const electricityMoveDate = state => state.electricity.moveDate;
const gasProduct = state => state.gas.product;
const gasRate = state => state.rates.gas;
const gasPreviousProvider = (state, getters, rootState) => {
  return rootState.common.gasProviders.find(provider => provider.id === state.gas.previousProvider);
}
const isGasGreen = state => state.gas.green;
const isGasMeterOpen = state => state.gas.meter.status === 'open';
const gasDeliveryDate = state => state.gas.deliveryDate;
const gasOpenMeterDate = state => state.gas.openMeterDate;
const gasMoveDate = state => state.gas.moveDate;
const sameOptions = (state, getters) => products => {
  let sameOptions = true;

  if(products.length > 1)
    sameOptions = products[1].peer && products[0].id === products[1].peer;

  return sameOptions;
}

const anyProduct = (state, getters) => {
  return state.electricity.product ? state.electricity.product : state.gas.product;
}

const deliveryAddress = (state) => {
  return state.address;
}

const isComfy = state => (product) => {
  let name = '';

  if(product !== null) {
    name = product.productName !== undefined ? product.productName : product.name;
  }

  return product !== null && name.toUpperCase().indexOf('COMFY') >= 0;
}

const elecEan = (state) => {
  return state.electricity.ean
}

const gasEan = (state) => {
  return state.gas.ean
}

const electricityMeterNumber = (state) => {
  return state.electricity.meter.number
}

const gasMeterNumber = (state) => {
  return state.gas.meter.number
}

const dynamicProductForced = (state, getters) => {
  return getters.anyProduct && getters.anyProduct.forced && getters.anyProduct.range === 'DYNAMIC';
}

const hasPrepaid = state => {
  return !!(state.electricity.product && state.electricity.product.range.includes(enums.productEnum.PREPAID) || state.gas.product && state.gas.product.range.includes(enums.productEnum.PREPAID));
}

const instalmentDaysDD = state => {
  return state.instalmentDaysDD;
}

const instalmentDaysBT = state => {
  return state.instalmentDaysBT;
}

const fromWallonia = state => {
  return state.address.locality.region === 'wl'
}

const fromFlanders = state => {
  return state.address.locality.region === 'vl'
}

export default {
  hasElec,
  hasGas,
  hasMono,
  hasTou,
  hasInjectionBase,
  hasInjectionTou,
  hasElecMeterType,
  hasNight,
  isTempOffer,
  electricityProduct,
  electricityRate,
  hasSolarPanel,
  electricitySolarPanelScenario,
  electricitySolarPanelPower,
  electricitySolarPanelNumber,
  electricitySolarPanelCertification,
  electricityPreviousProvider,
  isElectricityMeterOpen,
  electricityDeliveryDate,
  electricityOpenMeterDate,
  electricityMoveDate,
  gasProduct,
  gasRate,
  gasPreviousProvider,
  isGasGreen,
  isGasMeterOpen,
  gasDeliveryDate,
  gasOpenMeterDate,
  gasMoveDate,
  sameOptions,
  anyProduct,
  deliveryAddress,
  isComfy,
  elecEan,
  gasEan,
  electricityMeterNumber,
  gasMeterNumber,
  dynamicProductForced,
  hasPrepaid,
  instalmentDaysDD,
  instalmentDaysBT,
  fromWallonia,
  fromFlanders,
};



// WEBPACK FOOTER //
// ./src/store/modules/contract/getters.js